import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './LinearProgress.module.css';
import cn from 'classnames';

interface IProps {
    height?: number;
}

export const LinearProgress = ({
    height = 2,
    ...rest
}: IProps & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
    const { style = {}, className } = rest;
    return (
        <span className={cn(styles.linearProgress, className)} style={{ height: `${height}px`, ...style }} {...rest}>
            <span className={styles.linearProgressInner1} />
            <span className={styles.linearProgressInner2} />
        </span>
    );
};
